import React from "react";

import { GenericTableColumn } from "@ui-components/Table/GenericTable";


export interface License {
  id: number;
  subscription: string;
  type: string;
  description: string;
  startdate: string;
  enddate: string;
  activated: number;
  total: number;
  serial:string;
}


export const columns: GenericTableColumn<License>[] = [
  {
    header: "License",
    accessor: "serial",
  },
  {
    header: "Type",
    accessor: "type",
  },
  {
    header: "Description",
    accessor: "description",
  },
  {
    header: "Start Date",
    accessor: "startdate",
  },
  {
    header: "End date",
    accessor: "enddate",
  },
  {
    header: "Activations", 
    renderCell: (row: License) => (
      <div>
        {row.activated} of {row.total}
      </div>
    ),
  },
  {
    header: "Actions",
    // accessor es requerido por la interfaz, así que
    // podemos usar "subscription" para cumplir con el tipado,
    // pero aquí la celda vendrá sobrescrita en LicensingPage
    accessor: "subscription",
    renderCell: () => <div>Will be overridden in BgpPage</div>,
  },
];

